import React from "react";

const CheckIcon = ({ size = 12 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fff"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export default function Steps({ steps, activeSlug, onStepClick }) {
  const activeIndex = steps.findIndex((s) => s.slug === activeSlug);
  const safeActive = activeIndex < 0 ? 0 : activeIndex;
  const total = steps.length;
  const percent = total > 1 ? Math.round((safeActive / (total - 1)) * 100) : 0;

  return (
    <div className="pud-steps">
      <div className="pud-steps-progress">
        Step {safeActive + 1} of {total} · {percent}% complete
      </div>

      <div className="pud-steps-row">
        {steps.map((step, i) => {
          const isActive = i === safeActive;
          const isCompleted = i < safeActive;
          const isLast = i === steps.length - 1;
          const circleClass = [
            "pud-step-circle",
            isActive ? "active" : "",
            isCompleted ? "completed" : "",
          ]
            .filter(Boolean)
            .join(" ");

          return (
            <React.Fragment key={`marker-${step.slug}`}>
              <span className={circleClass} aria-hidden>
                {isCompleted ? <CheckIcon /> : i + 1}
              </span>
              {!isLast && (
                <span
                  className={`pud-step-connector ${
                    i < safeActive ? "completed" : ""
                  }`}
                  aria-hidden
                />
              )}
            </React.Fragment>
          );
        })}
      </div>

      <div className="pud-steps-cards">
        {steps.map((step, i) => {
          const isActive = i === safeActive;
          const isCompleted = i < safeActive;
          const cardClass = [
            "pud-step-card",
            isActive ? "active" : "",
            isCompleted ? "completed" : "",
          ]
            .filter(Boolean)
            .join(" ");

          return (
            <button
              key={step.slug}
              type="button"
              className={cardClass}
              disabled={step.disabled}
              onClick={() => !step.disabled && onStepClick?.(step.slug)}
              title={step.title}
            >
              <div className="pud-step-card-head">
                <span className="pud-step-card-num">STEP {i + 1}</span>
                {isCompleted && (
                  <span className="pud-step-card-check" aria-hidden>
                    <CheckIcon size={10} />
                  </span>
                )}
              </div>
              <div className="pud-step-card-title">{step.title}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
